import DayPartMonthly from "../day-part-monthly";
import DayPartHelper from "../day-part-helper";

class DayPartYearly extends DayPartMonthly {
  constructor(props) {
    super(props);
    this._helper = new DayPartHelper(props, "years");
  }

  _matchesMonth() {
    return [this._iterationStartDateTime.toFormat("MM"), this._iterationEndDateTime.toFormat("MM")].includes(
      this._atTime.toFormat("MM")
    );
  }

  _matchesDay() {
    return super._matchesDay() && this._matchesMonth();
  }
}

export default DayPartYearly;
